<template>
    <div class="del modal_wrapper">
        <!-- 제목 및 헤더 : 시작 -->
        <div class="sub_Navi">
            <ul>
                <li><a class="back" @click="closeModal">뒤로</a></li>
                <li>
                    <h1>{{ $t('price.coinReg') }}</h1>
                </li>
                <li class="linkBox">
                </li>
            </ul>
        </div>
        <!-- 제목 및 헤더 : 끝 -->
        <!-- 거래소 및 마켓 선택창, 검색창 : 시작 -->
        <div class="subPage_container">
            <div class="coin_search_wrap">
                <div>
                    <div class="select_wrap">
                        <input type="text" id="exchange" class="select w48 modal_open" :value="selectedExchange"
                            @click="showExchangeModal = true" readonly>
                        <input type="text" id="market" name="" class="select w48 modal_open" :value="selectedMarket"
                            @click="showMarketModal = true" readonly>
                    </div>
                    <div class="search_wrp">
                        <input type="text" id="search" name="search" class="search_input"
                            :placeholder="$t('alarm.score.searchCoin')" v-model="searchQuery">
                        <button class="search_clear" @click="searchQuery = ''"></button>
                    </div>
                </div>
            </div>
            <!-- 거래소 및 마켓 선택창, 검색창 : 끝 -->
            <!-- 코인 리스트 : 시작 -->
            <div class="coin_search_List fav">
                <ul>
                    <li v-for="(symbol, index) in allSymbolsList" :key="symbol.coin + '_' + index"
                        :class="{ 'on': isOriginallySelected(symbol) }">
                        <div class="lt_1">
                            <div class="coin_img">
                                <img :src="getImagePath(symbol.coin)" @error="handleImageError(symbol.coin, $event)" />
                            </div>
                            <h3 class="coin_name">{{ symbol.coin }}<span>/{{ symbol.quote }}</span></h3>
                        </div>
                        <div class="lt_2">{{ symbol.exchange }}</div>
                        <div class="lt_3">
                            <input type="checkbox" :id="'coinChk_' + symbol.coin + '_' + symbol.exchange"
                                @change="toggleCoinSelection(symbol)" :checked="isSelected(symbol)">
                            <label :for="'coinChk_' + symbol.coin + '_' + symbol.exchange"></label>
                        </div>
                    </li>
                </ul>
            </div>
            <!-- 코인 리스트 : 끝 -->
            <!-- 데이터가 없을 경우 -->
            <div class="nodata2" v-if="!allSymbolsList.length">{{ $t('price.noData') }}</div>
        </div>

        <!-- 하단 저장 버튼
            (클릭시 price-favorites API 호출,
            모달창 닫음,
            parent 새로고침 메세지 emit) -->
        <ModalBtn @click="handleModalBtnClick" />

        <!-- 거래소 모달창 : 시작 -->
        <div v-if="showExchangeModal">
            <div class="modalBackColor"></div>
            <div class="modal_wrap modal_no1">
                <div class="modal_title">
                    {{ $t('price.exchange') }}
                    <div class="mdcolsebtn" @click="showExchangeModal = false"></div>
                </div>
                <div class="modal_content">
                    <div class="modal_exchange_list">
                        <ul>
                            <li v-for="(exchange, index) in availableExchanges" :key="index" :class="{ active: selectedExchange == exchange}">
                                <div class="lt_1">
                                    <div class="exc_img">
                                        <img :src="getExchangeImage(exchange)" :alt="exchange" />
                                    </div>

                                    <h3 class="exc_name">{{ exchange }}</h3>
                                </div>
                                <div class="lt_2">
                                    <input type="radio" :id="'exChk_' + index" name="exChk"
                                        @change="selectExchange(exchange)">
                                    <label :for="'exChk_' + index"></label>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!-- 거래소 모달창 : 끝 -->
        <!-- 마켓 모달창 : 시작 -->
        <div v-if="showMarketModal">
            <div class="modalBackColor"></div>
            <div class="modal_wrap modal_no2" data-modal="2">
                <div class="modal_title">
                    {{ $t('price.selectMarket') }}
                    <div class="mdcolsebtn" @click="showMarketModal = false"></div>
                </div>
                <div class="modal_content">
                    <div class="modal_market_list">
                        <ul>
                            <li v-for="(market, index) in availableMarkets" :key="index" :class="{ active: selectedMarket == market }">
                                <div class="lt_1">
                                    <h3 class="market_name">{{ market }}</h3>
                                </div>
                                <div class="lt_2">
                                    <input type="radio" :id="'marketChk_' + index" name="marketChk"
                                        @change="selectMarket(market)">
                                    <label :for="'marketChk_' + index"></label>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <!-- 마켓 모달창 : 끝 -->
    </div>
    <div class="popupMessage">
        <span class="messageTxt"></span>
    </div>
    
    <!-- 에러 메세지 모달창 -->
    <ErrorModal :show="showErrorModal" :message="errorMessage" @close="showErrorModal = false" />
</template>

<script>
import api from '@/api/apiAuth.js';
import ModalBtn from '@/components/button/ModalBtn.vue';
import ErrorModal from '@/components/modal/ErrorModal.vue';

import { mapState, mapMutations } from 'vuex';
import { popupControll } from "@/utils/modalText";

export default {
    name: "CoinFavModal",
    components: {
        ModalBtn, // 저장 버튼
        ErrorModal, // 에러 메세지 모달창
    },
    data() {
        return {
            websocket: null,
            showErrorModal: false, // 에러 메세지 모달창 상태 변수
            errorMessage: '', // 에러 메세지 모달창 텍스트

            allSymbols: {}, // 소켓에서 불러온 모든 코인
            searchQuery: '', // 검색어 추적

            selectedExchange: this.$t('price.selectEx'), // 최초 실행시 거래소 선택 모달창 버튼에 보이는 텍스트
            showExchangeModal: false, // 거래소 선택 모달창 상태 변수
            availableExchanges: [], // 소켓에서 불러온 모든 거래소

            selectedMarket: this.$t('price.selectMarket'), // 최초 실행시 마켓 선택 모달창 버튼에 보이는 텍스트
            showMarketModal: false, // 마켓 선택 모달창 상태 변수
            availableMarkets: ['USDT', 'KRW'], // 고정값

            selectedCoins: [], // 유저가 선택하는 코인 어레이 (추적)
            priceFavorites: [], // price-favorites API에서 호출한 데이터
            fallbackLoaded: false
        }
    },
    emits: ['favoritesUpdated'],
    async created() {
        try {
            const response = await api.fetchPriceFavorites();
            if (response.isSuccess) {
                this.priceFavorites = response.data;
                this.selectedCoins = this.priceFavorites.map(fav => ({
                    exchange: fav.exchange,
                    quote: fav.quote,
                    coin: fav.coin
                }));
                this.connectWebSocket();
            }
        } catch (error) {
            // console.error('Error fetching price favorites:', error);
        }
    },
    mounted() {
        // history.pushState(null, '', location.href);
        // window.addEventListener('popstate', this.handleBack);
    },
    // 창이 닫히기 직전 소켓 연결 끊기
    beforeUnmount() {
        if (this.websocket) {
            this.websocket.close();
        }

        this.changeCoin({ state: false })
        this.resetScroll();
        // this.closeModal();
        // window.removeEventListener("popstate", this.handleBack);
    },
    computed: {
        // 모달창
        ...mapState('coinReg', ['clickAdd']),

        allSymbolsList() {
            let symbols = this.flattenSymbols();

            // Apply existing filters
            if (this.selectedExchange !== this.$t('price.selectEx')) {
                symbols = symbols.filter(s => s.exchange === this.selectedExchange);
            }
            if (this.selectedMarket !== this.$t('price.selectMarket')) {
                symbols = symbols.filter(s => s.quote === this.selectedMarket);
            }
            if (this.searchQuery) {
                const lowerCaseQuery = this.searchQuery.toLowerCase();
                symbols = symbols.filter(s =>
                    s.coin.toLowerCase().includes(lowerCaseQuery)
                );
            }

            // Sort symbols by keeping the originally selected coins at the top
            symbols.sort((a, b) => {
                const aSelected = this.isOriginallySelected(a);
                const bSelected = this.isOriginallySelected(b);
                return bSelected - aSelected;
            });

            return symbols;
        },
    },
    // 모든 코인에 대한 변화 관찰
    watch: {
        allSymbols: function (newVal) {
            this.availableExchanges = Object.keys(newVal);
        }
    },
    methods: {
        popupControll,

        handleBack() {
            // history.pushState(null, '', location.href); 
            this.closeModal();
        },

        // 모달창
        ...mapMutations('coinReg', ['changeCoin']),


        // 소켓 통신
        connectWebSocket() {
            this.websocket = new WebSocket('wss://ws1.goya-alert.com/exc');
            this.websocket.onopen = () => {
                this.websocket.send(JSON.stringify({ "exchange": "all", "type": "symbols" }));
            };
            this.websocket.onmessage = (event) => {
                const data = JSON.parse(event.data);
                if (data.all_symbols) {
                    this.$nextTick(() => {
                        this.allSymbols = data.all_symbols;
                        this.availableExchanges = Object.keys(data.all_symbols);
                    });
                }
            };
        },

        resetScroll() {
            const allElements = document.querySelectorAll('*');

            allElements.forEach(el => {
                if (el.scrollHeight > el.clientHeight || el.scrollWidth > el.clientWidth) {
                    el.scrollTo(0, 0);
                }
            });

            window.scrollTo(0, 0);
        },

        // 저장 버튼 함수
        async handleModalBtnClick() {
            if (this.selectedCoins.length >= 10) {
                this.popupControll(this.$t("popup.favoriteLimit"))
                return
            } else {
                try {
                    // console.log('handleModalBtnClick')
                    await api.updatePriceFavorites(this.selectedCoins);
                    this.changeCoin({ state: false })
                    this.$emit('favoritesUpdated');
                    this.$router.push('/price/favorite')
                } catch (error) {
                    this.showErrorModal = true;
                    this.errorMessage = "Failed to update price favorites: " + (error.response?.data?.message || error.message);
                    // console.error("Failed to update price favorites:", error);
                }
            }
        },

        // 코인별 이미지 호출
        getImagePath(coin) {
            const symbol = coin + 'USDT';
            const baseSymbol = symbol.replace('USDT', '').toLowerCase();
            try {
                return require('@/assets/images/coin_logos/' + baseSymbol + '.svg');
            } catch {
                return require('@/assets/images/coin_logos/default.svg');
            }
        },
        handleImageError(symbol, event) {
            const baseSymbol = symbol.replace('USDT', '').toLowerCase();
            event.target.src = require('@/assets/images/coin_logos/' + baseSymbol + '.png');
        },

        // 필터링 함수
        flattenSymbols() {
            return [].concat(...Object.values(this.allSymbols));
        },
        selectExchange(exchange) {
            this.selectedExchange = exchange !== this.$t('price.selectEx') ? exchange : '';
            this.showExchangeModal = false;
        },
        selectMarket(market) {
            this.selectedMarket = market !== this.$t('price.selectMarket') ? market : '';
            this.showMarketModal = false;
        },

        // 유저가 코인 선택시 selectedCoins 어레이에 추가, 선택헤제 시 어레이에서 삭제
        toggleCoinSelection(symbol) {
            const coinIndex = this.selectedCoins.findIndex(coin => coin.coin === symbol.coin && coin.exchange === symbol.exchange);
            if (coinIndex === -1) {
                this.selectedCoins.push({ exchange: symbol.exchange, quote: symbol.quote, coin: symbol.coin });
            } else {
                this.selectedCoins.splice(coinIndex, 1);
            }
        },
        isSelected(symbol) {
            return this.selectedCoins.some(selectedCoin =>
                selectedCoin.coin === symbol.coin && selectedCoin.exchange === symbol.exchange);
        },
        isOriginallySelected(symbol) {
            // Check if the symbol was part of the originally selected coins
            return this.priceFavorites.some(fav =>
                fav.coin === symbol.coin && fav.exchange === symbol.exchange
            );
        },

        // 거래소 이미지 가져오는 함수
        getExchangeImage(exchange) {
            if (!this.fallbackLoaded) {
                try {
                    return require(`@/assets/images/exchange/ec_${exchange.toLowerCase()}.png`);
                } catch (e) {
                    this.fallbackLoaded = true;
                    return `/assets/images/exchange/ec_${exchange.toLowerCase()}.png`;
                }
            } 
            else {
                return `/assets/images/exchange/ec_${this.exchange.toLowerCase()}.png`;
            }
        },
        closeModal() {
            // console.log('closeModal')
            // console.log("Vue history state:", window.history);
            // console.log("Vue history state:", window.history.state);
            // console.log("history length:", window.history.length);

            this.changeCoin({ state: false })
            if (window.history.state) {
                this.$router.back();
            }
            else {
                this.$router.push('/price/favorite');
            }
            // this.$router.back();
        }
    }
}
</script>

<style scoped>
.subPage_container {
    height: auto;
    background-color: var(--Grayscale-Gray100, #121415) !important;
}

.coin_search_wrap {
    background-color: var(--Grayscale-Gray100, #121415);
}

/*모달창*/
.modalBackColor {
    position: fixed;
    top: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 100%;
}

.modal_wrap {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 50dvh;
    background: var(--Menu-Dark, #222223);
    border-radius: 15px 15px 0 0;
    overflow-y: auto;
    display: block;
    justify-content: center;
    align-items: center;
}

/* 헤더를 제외한 콘텐츠 영역 */
.subPage_container {
    position: relative;
    height: calc(100dvh - 60px);
    padding-bottom: 90px; /* 저장 버튼에 리스트가 가리지 않도록 */
    overflow-y: auto;
    overscroll-behavior: contain;
    box-sizing: border-box;
    -webkit-overflow-scrolling: touch;
    background-color: rgba(0, 0, 0, 0.7);
}
</style>